const agencyCookies = [
  {
    agencyNumber: 9961, trackUrl: 'https://www.interchalet.de/w2/partnerlogo.cfm?agenturnr=A0010030', trackName: 'interchalet', trackType: 'script',
  }, // old interchalet agency number
  {
    agencyNumber: 93168, trackUrl: 'https://www.interchalet.de/pages/tracking/interhomelogo.aspx/?partnerID=IC0010030', trackName: 'interchalet', trackType: 'script',
  }, // new interchalet agency number
  {
    agencyNumber: 433050, trackUrl: 'https://www.tui-ferienhaus.de/scripts/fh/partnerlogo.php?agencykey=46566', trackName: 'tui', trackType: 'script',
  },
  {
    agencyNumber: 433050, trackUrl: 'https://www.tui-ferienhaus.de/scripts/fh/partnerlogo.php?agencykey=46566', trackName: 'tui', trackType: 'script',
  },
  {
    agencyNumber: 8610, trackUrl: 'https://www.dancenter.de/forms/cookie.php?ag=743050', trackName: 'dancenter', trackType: 'script',
  },
  {
    agencyNumber: 9118, trackUrl: 'https://www.belvilla.de/pt/edomizil2015/tracking/edomizil.js', trackName: 'belvilla', trackType: 'script',
  },
  {
    agencyNumber: 8695, trackUrl: 'https://www.interhome.de/Pages/Tracking/InterhomeLogo.aspx?partnerid=DE0591320', trackName: 'interhome', trackType: 'image',
  },
  {
    agencyNumber: 35546, trackUrl: 'http://www.vacasol.de/?campaignid=4A8E82C5-47A1-4BC6-8758-46073209B188', trackName: 'vacasol',
  },
  {
    agencyNumber: 8757, trackUrl: 'https://www.novasol.de/partnerlogo/2024790', trackName: 'novasol', trackType: 'script',
  },
];

export default agencyCookies;
